import React from "react";
import { useTranslation } from "react-i18next";

/**
 * "Load more" under a list (magazine, questions). A design-system button on
 * purpose: the template's .btn-primary is set by several competing
 * !important rules, and whichever lost decided whether its white text sat on
 * navy or on a transparent button over the page -- unreadable.
 */
export default function LoadMoreButton({ onClick, busy = false }) {
  const { t } = useTranslation();
  return (
    <div className="avc-load-more">
      <button type="button" className="avc-btn avc-btn--outline" onClick={onClick} disabled={busy} aria-busy={busy || undefined}>
        {t("Load_More")}
      </button>
    </div>
  );
}
